import { useCallback } from "react";
import { DEFAULT_WHATSAPP_COMMUNITY_URL } from "./ReferrersCommunity.constants";

export const useReferrersCommunity = (whatsappCommunityUrl) => {
  const activeCommunityUrl =
    whatsappCommunityUrl || DEFAULT_WHATSAPP_COMMUNITY_URL;

  const handleJoinCommunity = useCallback(() => {
    if (activeCommunityUrl && typeof window !== "undefined") {
      window.open(activeCommunityUrl, "_blank", "noopener,noreferrer");
    }
  }, [activeCommunityUrl]);

  return {
    handleJoinCommunity,
    activeCommunityUrl,
  };
};
